module.exports = __webpack_public_path__ + "static/media/8604-f-r.cc30b612.png";